import { View } from "react-native-web";
import { CImage } from "../../../components/atoms";
import { Constants, Images } from "../../../config";

export const casinoFilterCriteria = (isMobileVersion, styles) => {
  return [
    {
      title: "Location",
      isHide: isMobileVersion,
      isLocation: true,
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_STATUS,
      icon: Images.iconTagStatus,
      width: 20,
      height: 20,
      title: "Status",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Open",
          tagId: 1,
        },
        {
          id: 2,
          label: "Closed",
          tagId: 2,
        },
        {
          id: 3,
          label: "Temporarily Closed",
          tagId: 4,
        },
        {
          id: 4,
          label: "Permanently Closed",
          tagId: 3,
        },
      ],
      selectedList: [1, 2, 4],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_CASINO_CATEGORY,
      icon: Images.iconTagEventType,
      width: 20,
      height: 20,
      title: "Category",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Basic",
          tagId: 5101,
        },
        {
          id: 2,
          label: "Premium",
          tagId: 5102,
        },
        {
          id: 3,
          label: "Luxury",
          tagId: 5103,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_CASINO_FEATURE,
      icon: Images.iconTagFeature,
      width: 20,
      height: 20,
      title: "Features",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Hotel",
          tagId: 5201,
        },
        {
          id: 2,
          label: "Restaurant",
          tagId: 5202,
        },
        {
          id: 3,
          label: "Bar",
          tagId: 5203,
        },
        {
          id: 4,
          label: "Nightlife",
          tagId: 5204,
        },
        {
          id: 5,
          label: "Attraction",
          tagId: 5205,
        },
        {
          id: 6,
          label: "Shop",
          tagId: 5206,
        },
        {
          id: 7,
          label: "Pool",
          tagId: 5207,
        },
        {
          id: 8,
          label: "Spa",
          tagId: 5208,
        },
        {
          id: 9,
          label: "Golf",
          tagId: 5209,
        },
        {
          id: 10,
          label: "Convention",
          tagId: 5210,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_CASINO_GAMES,
      icon: Images.iconTagStatus,
      width: 20,
      height: 20,
      title: "Games",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Casino",
          tagId: 5301,
        },
        {
          id: 2,
          label: "Poker",
          tagId: 5302,
        },
        {
          id: 3,
          label: "Machine Games",
          tagId: 5303,
        },
        {
          id: 4,
          label: "Bingo",
          tagId: 5304,
        },
        {
          id: 5,
          label: "Horse Racing",
          tagId: 5305,
        },
        {
          id: 6,
          label: "Sportsbook",
          tagId: 5306,
        },
        {
          id: 7,
          label: "Greyhounds",
          tagId: 5307,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT,
      icon: Images.iconTagSize,
      width: 20,
      height: 20,
      title: "Size",
      isHide: false,
      isRangeValue: true,
      detailList: [
        {
          id: 1,
          label: "XS",
          suffix: "0 - 10K sqft",
          value: { minValue: 0, maxValue: 10000 },
        },
        {
          id: 2,
          label: "S",
          suffix: "10K - 50K sqft",
          value: { minValue: 10000, maxValue: 50000 },
        },
        {
          id: 3,
          label: "M",
          suffix: "50K - 200K sqft",
          value: { minValue: 50000, maxValue: 200000 },
        },
        {
          id: 4,
          label: "L",
          suffix: "200K - 500K sqft",
          value: { minValue: 200000, maxValue: 500000 },
        },
        {
          id: 5,
          label: "XL",
          suffix: "500K - 1M sqft",
          value: { minValue: 500000, maxValue: 1000000 },
        },
        {
          id: 6,
          label: "XXL",
          suffix: "+1M sqft",
          value: { minValue: 1000000 },
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_RATING,
      icon: Images.iconTagRating,
      width: 21.5,
      height: isMobileVersion ? 21 : 20,
      title: "Rating",
      isHide: true,
      isRating: true,
      detailList: [
        {
          id: 1,
          label: "1",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating1}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 2,
          label: "2",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating2}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 3,
          label: "3",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating3}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 4,
          label: "4",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating4}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 5,
          label: "5",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating5}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
      ],
      selectedList: [],
    },
  ];
};
